import BrandMoment from './BrandMoment';
import Hero from './Hero';
import InternalLinks from './InternalLinks';
import BudgetFriendlyCarousel from '../common/BudgetFriendlyCarousel';
import MarketingCarousel from '../common/MarketingCarousel';
import PopularBodyStyles from '../common/PopularBodyStyles';
import PriceDropBanner from '../common/PriceDropBanner';
import ShopPopularModels from '../common/ShopPopularModels';

export default function NewUser() {
  return (
    <main data-testid="home-new-user" className="min-h-screen bg-white">
      <Hero />
      <PopularBodyStyles />
      <BudgetFriendlyCarousel />
      <ShopPopularModels />
      <PriceDropBanner />
      <MarketingCarousel />
      <BrandMoment>
        <InternalLinks />
      </BrandMoment>
    </main>
  );
}
